import { useEffect, useState } from 'react'
import './spotlight-overlay.css'

interface SpotlightOverlayProps {
	target: string
	padding?: number
	onClickOutside?: () => void
}

export function SpotlightOverlay({ target, padding = 8, onClickOutside }: SpotlightOverlayProps) {
	const [rect, setRect] = useState<DOMRect | null>(null)

	useEffect(() => {
		const element = document.querySelector(target)
		if (element) {
			setRect(element.getBoundingClientRect())
		}

		const handleResize = () => {
			const el = document.querySelector(target)
			if (el) setRect(el.getBoundingClientRect())
		}

		window.addEventListener('resize', handleResize)
		window.addEventListener('scroll', handleResize, true)
		return () => {
			window.removeEventListener('resize', handleResize)
			window.removeEventListener('scroll', handleResize, true)
		}
	}, [target])

	if (!rect) return null

	return (
		<div className="spotlight-overlay" data-testid="spotlight-overlay" onClick={onClickOutside}>
			<div
				className="spotlight-overlay__cutout"
				data-testid="spotlight-cutout"
				style={{
					top: rect.top - padding,
					left: rect.left - padding,
					width: rect.width + padding * 2,
					height: rect.height + padding * 2,
				}}
				onClick={(e) => e.stopPropagation()}
			/>
		</div>
	)
}
